import { render, staticRenderFns } from "./IdentifyVerification.vue?vue&type=template&id=146ecf3e"
import script from "./IdentifyVerification.vue?vue&type=script&lang=js"
export * from "./IdentifyVerification.vue?vue&type=script&lang=js"
import style0 from "./IdentifyVerification.vue?vue&type=style&index=0&id=146ecf3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports